import React, { useState } from 'react';
import './OchelariDeVedere.css';

export default function OchelarideVedere() {
    const [isFormVisible, setIsFormVisible] = useState(false);

    const handleToggleForm = () => {
        setIsFormVisible(!isFormVisible);
    };

    return (
        <div>
            {/* Hero Section */}
            <div className="hero-section position-relative">
                <img src="./Imagini/vederefront1.jpg" className="hero-image img-fluid" alt="Ochelari de Vedere" />
                <div className="overlay position-absolute w-100 h-100 d-flex flex-column justify-content-center align-items-center text-white">
                    <h1 className="main-title">OCHELARI DE VEDERE</h1>
                    <h4 className="subtitle">Modele pentru stilul tău</h4>
                </div>
            </div>

            {/* Collection Section */}
            <div className="container text-center mb-5">
                <h1 className="mb-4">Colecția de Ochelari de Vedere</h1>
                <p className="lead">Alege rame care îți completează stilul și îți asigură confortul vizual.</p>
            </div>

            {/* Product Cards */}
            <div className="container">
                <div className="row row-cols-1 row-cols-md-3 g-4">
                    {/* Classic Glasses */}
                    <div className="col">
                        <div className="card product-card">
                            <img src="imagini/medical-2720562_1280.jpg" className="card-img-top" alt="Ochelari de Vedere Clasic" />
                            <div className="card-body">
                                <h5 className="card-title">Ochelari de Vedere cu design Clasic - Eleganță și Funcționalitate</h5>
                                <p className="card-text">
                                Ochelarii de vedere cu design Clasic combină stilul atemporal cu confortul și claritatea vizuală, fiind alegerea perfectă pentru oricine apreciază simplitatea elegantă. 
                                    Cu un design subtil, potrivit pentru orice ocazie, acești ochelari se adaptează cu ușurință atât unei ținute de birou, cât și uneia casual. 
                                    Ramele sunt create pentru a fi durabile și confortabile, iar lentilele de înaltă calitate asigură o vedere clară și relaxată.
                                    Alege ochelarii de vedere Clasic pentru un aspect sofisticat și o performanță vizuală optimă.
                                </p>
                                <a href="#" className="btn btn-primary">Vezi detalii</a>
                            </div>
                        </div>
                    </div>

                    {/* Modern Glasses */}
                    <div className="col">
                        <div className="card product-card">
                            <img src="imagini/glasses-1830474_1280.jpg" className="card-img-top" alt="Ochelari de Vedere Moderni" />
                            <div className="card-body">
                                <h5 className="card-title">Ochelari de Vedere Moderni - Stil Contemporan și Performanță Vizuală de Top</h5>
                                <p className="card-text">
                                Ochelarii de vedere Moderni sunt concepuți pentru cei care doresc să îmbine funcționalitatea cu un design contemporan. 
                                    Cu linii elegante și forme inovatoare, acești ochelari oferă un aspect modern, ideal pentru a completa orice ținută urbană sau profesională.
                                    Ramele ușoare și rezistente sunt realizate din materiale de înaltă calitate, oferind un confort de lungă durată și un aspect sofisticat.
                                    Alege ochelarii de vedere Moderni pentru un look actual și o viziune impecabilă.
                                </p>
                                <a href="#" className="btn btn-primary">Vezi detalii</a>
                            </div>
                        </div>
                    </div>

                    {/* Unisex Glasses */}
                    <div className="col">
                        <div className="card product-card">
                            <img src="imagini/pexels-stephen-niemeier-131018.jpg" className="card-img-top" alt="Ochelari de Vedere Unisex" />
                            <div className="card-body">
                                <h5 className="card-title">Ochelari de Vedere Unisex - Versatilitate și Confort pentru Toată Lumea</h5>
                                <p className="card-text">
                                    Ochelarii de vedere Unisex sunt perfecți pentru cei care apreciază un design simplu, dar rafinat, potrivit pentru orice stil și orice ocazie.
                                    Ramele versatile sunt confecționate din materiale ușoare și durabile, oferind un confort deosebit chiar și la purtări îndelungate.
                                    Lentilele de calitate superioară asigură o vedere clară și protecție optimă pentru ochi, fie că ești la birou, la școală sau în timpul activităților recreative.
                                    Alege această opțiune pentru o potrivire universală și o estetică plăcută.
                                </p>
                                <a href="#" className="btn btn-primary">Vezi detalii</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Promo Section */}
            <div className="container promo my-5">
                <h3>Ocazional oferte speciale si pachete promotionale!</h3>
                <p>Vino la noi și beneficiază de consultanții personalizate pentru a-ți alege ochelarii de vedere potriviți.</p>
                <button className="btn btn-success" onClick={handleToggleForm}>
                    Programează-te acum
                </button>
            </div>

            {/* Form Section - Hidden Initially */}
            {isFormVisible && (
                <div className="container my-5">
                    <h2>Programare pentru Consultație</h2>
                    <form>
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">Nume</label>
                            <input type="text" className="form-control" id="name" required />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">Email</label>
                            <input type="email" className="form-control" id="email" required />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="phone" className="form-label">Telefon</label>
                            <input type="tel" className="form-control" id="phone" required />
                        </div>
                        <button type="submit" className="btn btn-primary">Trimite</button>
                    </form>
                </div>
            )}
        </div>
    );
}
